export const SHARED_STYLES = {
  widgetTitle: 'font-metricRSemibold text-sm text-bw08 leading-4',
};

export const ACTION_TYPES = {
  BUSINESS: 'BUSINESS',
  PERSONAL: 'PERSONAL',
  SPLIT: 'SPLIT',
  APPROVE: 'APPROVE',
  NOT_NOW: 'NOT_NOW',
} as const;

export const showInsights = true;

export const showBillsInvoicesGusto = true;
